// routes
import { User } from 'src/types/user';
// utils
import axios, { endpoints, setSession } from 'src/utils/axios';

// ----------------------------------------------------------------------

export const jwtLogin = async (
  id: string,
  password: string
): Promise<{
  accessToken: string;
  user: User;
  require_password_change?: boolean;
}> => {
  if (!id || !password) {
    throw new Error('ID and password are required');
  }

  const data = {
    id,
    password,
  };

  const response = await axios.post<{
    token: string;
    refreshToken: string;
    user: User;
    require_password_change?: boolean;
  }>(endpoints.auth.login, data);

  const { token, user, require_password_change } = response.data;

  setSession(token);

  return {
    accessToken: token,
    user,
    require_password_change,
  };
};
